import { createContext } from 'react';

const useAreaImprovementContext = createContext();
export default useAreaImprovementContext;
